import * as React from 'react';
/**
 *
 * Original name: One Click NDA
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29923%3A6771
 *
 */
export const OneClickNdaPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M37 18V7h-4v11h4Zm-8.586 1.586-8-8-2.828 2.828 8 8 2.828-2.828Zm16 2.828 8-8-2.828-2.828-8 8 2.828 2.828ZM46 31h11v-4H46v4Zm-4.414 7.414 8 8 2.828-2.828-8-8-2.828 2.828Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.5 56 22 42 8 34.5 40 24 29.5 56Zm-.887-10.127-3.658-6.828-6.828-3.658 15.607-5.121-5.121 15.608Z", fill: "currentColor" })));
